(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vva-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initHeroVideos(root = document) {
    root.querySelectorAll('[data-vva-hero-video]').forEach(wrapper => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.vvaMediaReady === 'true') return;
      video.dataset.vvaMediaReady = 'true';
      video.defaultMuted = true;
      video.muted = true;
      const errorMessage = wrapper.querySelector('.vva-video-error');
      video.addEventListener('error', () => { if (errorMessage) errorMessage.hidden = false; });
      video.addEventListener('loadeddata', () => { if (errorMessage) errorMessage.hidden = true; });
      if (video.error && errorMessage) errorMessage.hidden = false;
      const saveData = navigator.connection && navigator.connection.saveData;
      if (wrapper.dataset.vvaAutoplay === 'true' && !reducedMotion.matches && !saveData) {
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      }
    });
  }
  function motionChanged(event) {
    if (event.matches) document.querySelectorAll('[data-vva-hero-video] video').forEach(video => video.pause());
  }
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', motionChanged);
  else if (reducedMotion.addListener) reducedMotion.addListener(motionChanged);
  document.addEventListener('shopify:section:load', event => initHeroVideos(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHeroVideos());
  else initHeroVideos();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vva-product-restored"]) return;
  try {
    
(() => {
  'use strict';
  if (window.VVProductRestored) { window.VVProductRestored.init(); return; }
  const cache = new WeakMap();
  function variants(scope) {
    if (!cache.has(scope)) {
      const source = scope.querySelector('[data-vva-variants]');
      try { cache.set(scope, JSON.parse(source ? source.textContent : '[]')); }
      catch (_) { cache.set(scope, []); }
    }
    return cache.get(scope);
  }
  function swapImage(scope, source, alt) {
    const image = scope.querySelector('.vva-gallery-current');
    if (!image || !source) return;
    image.removeAttribute('srcset'); image.removeAttribute('sizes');
    image.src = source; image.alt = alt || '';
    scope.querySelectorAll('[data-vva-image]').forEach(link => {
      if (link.dataset.vvaImage === source) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }
  function updateVariant(scope, changeHistory = false) {
    const input = scope.querySelector('.vva-product-form [name="id"]');
    if (!input) return;
    const variant = variants(scope).find(item => String(item.id) === input.value);
    const comingSoon = scope.dataset.comingSoon === 'true';
    const available = Boolean(variant && variant.available && !comingSoon);
    scope.querySelectorAll('[data-vva-buy]').forEach(button => {
      button.disabled = !available;
      button.textContent = comingSoon ? scope.dataset.comingSoonLabel : (variant ? (available ? scope.dataset.addLabel : scope.dataset.soldOut) : scope.dataset.unavailable);
    });
    scope.querySelectorAll('[data-vva-price]').forEach(node => { node.textContent = variant ? variant.price : ''; });
    scope.querySelectorAll('[data-vva-compare]').forEach(node => {
      node.textContent = variant && variant.compare || ''; node.hidden = !variant || !variant.compare;
    });
    scope.querySelectorAll('[data-vva-accelerated]').forEach(node => { node.hidden = !available; });
    const status = scope.querySelector('[data-vva-availability]');
    if (status) status.textContent = comingSoon ? scope.dataset.comingSoonLabel : (!variant ? scope.dataset.unavailable : (!available ? scope.dataset.soldOut : (variant.confirmDispatch ? scope.dataset.confirmLabel : scope.dataset.orderLabel)));
    if (!variant) return;
    const quantity = scope.querySelector('[data-vva-quantity]');
    if (quantity) {
      const min = Math.max(1, Number(variant.min) || 1);
      const step = Math.max(1, Number(variant.step) || 1);
      const max = variant.max == null ? null : Number(variant.max);
      quantity.min = String(min); quantity.step = String(step);
      if (max !== null && Number.isFinite(max)) quantity.max = String(max); else quantity.removeAttribute('max');
      const raw = Number(quantity.value);
      let value = min + Math.ceil(Math.max(0, (Number.isFinite(raw) ? raw : min) - min) / step) * step;
      if (max !== null && Number.isFinite(max)) value = Math.min(value, min + Math.floor(Math.max(0, max - min) / step) * step);
      quantity.value = String(value);
    }
    swapImage(scope, variant.image || scope.dataset.defaultImage, variant.image ? variant.imageAlt : scope.dataset.defaultAlt);
    if (changeHistory) {
      const url = new URL(window.location.href); url.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', url.toString());
    }
    scope.dispatchEvent(new CustomEvent('vva:variant-change', { bubbles: true, detail: { variant } }));
  }
  function init(root = document) {
    root.querySelectorAll('.vvp-restored [data-vva-product]').forEach(scope => {
      if (scope.dataset.vvpReady === 'true') return;
      scope.dataset.vvpReady = 'true'; updateVariant(scope);
    });
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.vvp-restored [data-vva-image]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const scope = link.closest('[data-vva-product]');
    if (!scope || !scope.querySelector('.vva-gallery-current')) return;
    event.preventDefault(); swapImage(scope, link.dataset.vvaImage, link.dataset.vvaImageAlt);
  });
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element) || !event.target.matches('.vvp-restored [data-vva-variant]')) return;
    const scope = event.target.closest('[data-vva-product]'); if (scope) updateVariant(scope, true);
  });
  document.addEventListener('submit', event => {
    if (!(event.target instanceof Element) || !event.target.matches('.vvp-restored .vva-product-form')) return;
    const scope = event.target.closest('[data-vva-product]');
    const input = event.target.querySelector('[name="id"]');
    const variant = scope && input && variants(scope).find(item => String(item.id) === input.value);
    if (!variant || !variant.available || scope.dataset.comingSoon === 'true') { event.preventDefault(); if (scope) updateVariant(scope); }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => document.querySelectorAll('.vvp-restored [data-vva-product]').forEach(scope => updateVariant(scope)));
  window.addEventListener('popstate', () => {
    const id = new URL(window.location.href).searchParams.get('variant');
    document.querySelectorAll('.vvp-restored [data-vva-product]').forEach(scope => {
      const input = scope.querySelector('[data-vva-variant]');
      if (input && id && variants(scope).some(item => String(item.id) === id)) { input.value = id; updateVariant(scope); }
    });
  });
  window.VVProductRestored = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();


  } catch(e) { console.error(e); }
})();
})();
